function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React, { Component } from 'react';
import uri from 'urijs';
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import * as styles from './ProviderStyles.js';
import { window } from '@wix/photography-client-lib';

/* eslint-disable react/prop-types, no-case-declarations, no-mixed-operators */
var ProviderIntent = /*#__PURE__*/function (_Component) {
  function ProviderIntent(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleMessageReceived = _this.handleMessageReceived.bind(_this);
    _this.onBackToEditor = _this.onBackToEditor.bind(_this);
    _this.handleWixStyleChanged = _this.handleWixStyleChanged.bind(_this);
    _this.setTabIndex = _this.setTabIndex.bind(_this);
    _this.api = props.api;
    var anonymousUserId = _this.api.getAnonymousUserId();
    var providerData = null;
    var providerId = null;
    var debugApp = props.debugApp || window.debugApp;
    var connectedProviders = props.connectedProviders;
    _this.api.isVisualFocusEnabled().then(function (isEnabled) {
      _this.setState({
        isAccessible: isEnabled,
        readyToRender: true
      });
    });
    if (connectedProviders) {
      var providerDataProps = _this.getProviderDataFromConnectedProviders(connectedProviders);
      providerData = providerDataProps.providerData;
      providerId = providerDataProps.providerId;
    }
    _this.state = {
      providerData: providerData,
      providerId: providerId,
      token: _this.getUUID(),
      anonymousUserId: anonymousUserId,
      isAccessible: false,
      providerReady: false,
      debugApp: debugApp,
      readyToRender: false,
      intentFrame: null
    };
    _this.getProviderBaseUrl = _this.getProviderBaseUrl.bind(_this);
    _this.isDashboard = _this.isDashboard.bind(_this);
    _this.isEditor = _this.isEditor.bind(_this);
    _this.isPreview = _this.isPreview.bind(_this);
    _this.raiseEvent = _this.raiseEvent.bind(_this);
    _this.shouldComponentUpdate = _this.shouldComponentUpdate.bind(_this);
    _this.isSite = _this.isSite.bind(_this);
    _this.backHome = _this.backHome.bind(_this);
    _this.getSiteUrlsBundle = _this.getSiteUrlsBundle.bind(_this);
    _this.sendStylesToProvider = _this.sendStylesToProvider.bind(_this);
    _this.hasWixSdk = _this.hasWixSdk.bind(_this);
    _this.postMessage = _this.postMessage.bind(_this);
    _this.onFrameCreated = _this.onFrameCreated.bind(_this);
    _this.hasDebug = _this.hasDebug.bind(_this);
    return _this;
  }
  _inheritsLoose(ProviderIntent, _Component);
  var _proto = ProviderIntent.prototype;
  _proto.getUUID = function getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };
  _proto.isDashboard = function isDashboard() {
    return this.api.getViewMode() === 'dashboard';
  };
  _proto.isEditor = function isEditor() {
    return this.api.getViewMode() === 'editor';
  };
  _proto.isPreview = function isPreview() {
    return this.api.getViewMode() === 'preview';
  };
  _proto.handleWixStyleChanged = function handleWixStyleChanged() {
    var _this2 = this;
    // This timeout will let the params a chance to be set
    setTimeout(function () {
      _this2.sendStylesToProvider();
    }, 1);
  };
  _proto.getProviderDataFromConnectedProviders = function getProviderDataFromConnectedProviders(connectedProviders) {
    var providerData = null;
    var providerId = null;
    if (connectedProviders) {
      providerId = Object.keys(connectedProviders)[0];
      providerData = connectedProviders[providerId];
    }
    return {
      providerData: providerData,
      providerId: providerId
    };
  };
  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var nextProviderData = this.getProviderDataFromConnectedProviders(nextProps.connectedProviders);
    var currentProviderId = this.getProviderDataFromConnectedProviders(this.props.connectedProviders);
    if (nextProviderData.providerId !== currentProviderId.providerId) {
      this.setState({
        providerData: nextProviderData.providerData,
        providerId: nextProviderData.providerId,
        providerReady: false,
        intentFrame: null
      });
    }
  };
  _proto.raiseEvent = function raiseEvent(eventType, data, resolve, reject) {
    if (this.props.onMessageReceived) {
      this.props.onMessageReceived(eventType, data, resolve, reject, this.state.providerId);
    }
  };
  _proto.setTabIndex = function setTabIndex(idx) {
    if (this.state.intentFrame) {
      this.state.intentFrame.tabIndex = idx;
    }
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return !this.state.intentFrame; // prevent iframe from refreshing
  };
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('message', this.handleMessageReceived);
    this.api.attachEditModeChanged(this.onBackToEditor);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('message', this.handleMessageReceived);
    this.api.dettachEditModeChanged(this.onBackToEditor);
  };
  _proto.isSite = function isSite() {
    return !this.isEditor() && !this.isPreview();
  };
  _proto.onBackToEditor = function onBackToEditor() {
    var _this3 = this;
    if (this.props.hiddenFromEditor === true && !this.isSite()) {
      // If we don't do the following checks then if the hidden page is not visible, the SDK will make a short jump to that page before navigating to home..
      // This way we make sure that the current pageId is not a hidden page - thus we should not navigate at all..
      this.api.getCurrentPageId().then(function (currentPageId) {
        _this3.api.getSitePages().then(function (arrPages) {
          var isInSitePages = arrPages.some(function (page) {
            return page.id === currentPageId;
          });
          if (!isInSitePages) {
            _this3.backHome();
          }
        });
      });
    }
  };
  _proto.backHome = function backHome(payload) {
    var _this4 = this;
    if (!this.hasWixSdk()) {
      return;
    } else {
      if (!this.isEditor()) {
        try {
          this.api.replaceSectionState('/');
        } catch (e) {
          console.error('failed replacing section state', e);
        }
      }
      this.api.getSitePages().then(function (arrPages) {
        var homepage = (arrPages || []).find(function (page) {
          return page.isHomepage;
        });
        if (homepage) {
          var homepageId = homepage.id;
          if (payload) {
            if (payload.openCart) {
              localStorage.setItem('openCart', true);
            }
          }
          _this4.api.navigateToPage(homepageId);
        }
      });
    }
  };
  _proto.getSiteUrlsBundle = function getSiteUrlsBundle() {
    var arrPromises = [];
    var returnPromise = null;
    if (!this.isDashboard()) {
      var dashboardPromise = Promise.resolve(null);
      arrPromises.push(this.api.getSiteInfo());
      arrPromises.push(this.api.getSectionUrl('checkout_page'));
      arrPromises.push(this.api.getSectionUrl('thank_you_page'));
      if (this.isEditor()) {
        dashboardPromise = this.api.getDashboardAppUrl().then(function (url) {
          // For some reason - the value does not have the protocol section ( http: ), so we add it ourselves..
          return uri(url).protocol('http').search({
            appState: '#'
          }).toString();
        });
      }
      arrPromises.push(dashboardPromise);
      returnPromise = Promise.all(arrPromises).then(function (results) {
        var siteUrl = results[0].baseUrl;
        var url = results[0].url;
        var checkoutUrl = uri(results[1].url).toString();
        var thankYouUrl = uri(results[2].url).toString();
        var dashboardUrl = results[3];
        var result = {
          checkoutUrl: checkoutUrl,
          thankYouUrl: thankYouUrl,
          siteUrl: siteUrl,
          url: url,
          dashboardUrl: dashboardUrl
        };
        return result;
      });
    } else {
      returnPromise = Promise.reject('Cannot get urls when viewMode is "dashboard"');
    }
    return returnPromise;
  };
  _proto.sendStylesToProvider = function sendStylesToProvider() {
    var _this5 = this;
    var _this$props = this.props,
      preventStyles = _this$props.preventStyles,
      styleParams = _this$props.styleParams;
    if (!preventStyles) {
      styles.getStyles(styleParams || {}, this.api).then(function (css) {
        _this5.postMessage(providerEvents.css, css);
      });
    }
  };
  _proto.hasWixSdk = function hasWixSdk() {
    var wixApi = this.api.wixApi;
    return wixApi && !wixApi.isMock;
  };
  _proto.handleMessageReceived = function handleMessageReceived(event) {
    var _this6 = this;
    var providerData = this.state.providerData;
    if (event.data && this.hasWixSdk() && this.api.isStyleChanged(event.data.type)) {
      this.handleWixStyleChanged();
    }
    // This check is because the provider may get messages that did not originate from the provider.. So we might get messages before the provider is loaded.
    if (providerData) {
      var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
      var data = event.data;
      var intentUrl = this.getProviderBaseUrl();
      if (intentUrl && intentUrl.indexOf(origin) === 0) {
        var type = data.type,
          token = data.token,
          payload = data.payload,
          callbackId = data.callbackId;
        var resolve = function resolve() {};
        var reject = function reject() {};
        if (callbackId) {
          resolve = function resolve(payload) {
            _this6.postMessage(providerEvents.callback, {
              payload: payload,
              callbackId: callbackId,
              resolved: true
            });
          };
          reject = function reject(payload) {
            _this6.postMessage(providerEvents.callback, {
              payload: payload,
              callbackId: callbackId,
              resolved: false
            });
          };
        }
        try {
          if (this.state.token && token === this.state.token) {
            if (process.env.NODE_ENV === 'development') {
              console.log("Provider intent message received: type: " + type + " | intent " + this.props.intent);
            }
            switch (type) {
              case providerEvents.sdkReady:
                if (this.loader) {
                  this.loader.style.display = 'none';
                }
                this.setState({
                  providerReady: true
                }, function () {
                  _this6.sendStylesToProvider();
                });
                this.api.applicationLoaded();
                console.timeEnd("Provider intent iframe load time - " + this.props.intent);
                break;
              case providerEvents.backHome:
                this.backHome(payload);
                break;
              case providerEvents.getSiteProperties:
                var getSiteProperties = this.props.getSiteProperties;
                if (typeof getSiteProperties === 'function') {
                  getSiteProperties().then(function (properties) {
                    resolve(properties);
                  });
                } else {
                  resolve({});
                }
                break;
              case providerEvents.navigateToUrl:
                var url = payload.url;
                window.top.location.href = url;
                break;
              case providerEvents.getSiteUrls:
                this.getSiteUrlsBundle().then(function (urls) {
                  resolve(urls);
                })["catch"](function (err) {
                  reject(err);
                });
                break;
              case providerEvents.getStyles:
                styles.getStyles(this.props.styleParams || {}, this.api).then(function (css) {
                  resolve(css);
                });
                break;
              default:
                break;
            }
            this.raiseEvent(type, payload, resolve, reject, providerData.providerId);
          }
        } catch (error) {
          console.error("Error handling provider event. Type: " + type + " | payload: " + payload, error);
          if (reject) {
            reject('Error');
          }
        }
      }
    } else {
      // TODO: do something smart
    }
  };
  _proto.postMessage = function postMessage(type, payload) {
    var token = this.state.token;
    var intentUrl = this.getProviderBaseUrl();
    var success = false;
    if (this.state.intentFrame && type && payload) {
      var obj = {
        type: type,
        token: token,
        payload: payload
      };
      var providerReady = this.state.providerReady;
      if (providerReady) {
        this.state.intentFrame.contentWindow.postMessage(obj, intentUrl);
        success = true;
      } else {
        // console.error(`cannot send provider message - type: ${type} | intent: ${intent} | payload:`, payload);
      }
    }
    return success;
  };
  _proto.onFrameCreated = function onFrameCreated(element) {
    console.time("Provider intent iframe load time - " + this.props.intent);
    this.setState({
      intentFrame: element
    });
    if (this.props.onFrameCreated) {
      this.props.onFrameCreated();
    }
  };
  _proto.hasDebug = function hasDebug() {
    var debugApp = this.state.debugApp;
    return debugApp && typeof debugApp === typeof '';
  };
  _proto.getProviderBaseUrl = function getProviderBaseUrl() {
    var url = null;
    var _this$state = this.state,
      providerData = _this$state.providerData,
      debugApp = _this$state.debugApp;
    var intent = this.props.intent;
    if (providerData && intent) {
      var widgets = providerData.widgets;
      if (widgets) {
        var baseUrl = widgets[intent];
        if (baseUrl) {
          url = baseUrl.url;
          if (this.hasDebug()) {
            var providerHostKey = 'ph_pvdr_host_';
            var arrDebugAppParts = debugApp.split('|');
            var newHostPart = arrDebugAppParts.find(function (part) {
              return part.indexOf(providerHostKey) === 0;
            });
            if (newHostPart) {
              var encodedHost = newHostPart.substring(providerHostKey.length);
              var newHost = decodeURIComponent(encodedHost);
              url = uri(url).hostname(newHost).toString();
            }
          }
        }
      }
    }
    return url;
  };
  _proto.render = function render() {
    var _this7 = this;
    var _this$state2 = this.state,
      providerData = _this$state2.providerData,
      anonymousUserId = _this$state2.anonymousUserId,
      debugApp = _this$state2.debugApp,
      readyToRender = _this$state2.readyToRender;
    if (!providerData || !providerData.widgets || !readyToRender) {
      return /*#__PURE__*/React.createElement("div", {
        className: "circle-preloader"
      });
    }
    var _this$props2 = this.props,
      intent = _this$props2.intent,
      locale = _this$props2.locale,
      deviceType = _this$props2.deviceType,
      viewMode = _this$props2.viewMode,
      additionalParams = _this$props2.additionalParams,
      customAdditionalParams = _this$props2.customAdditionalParams,
      additionalPath = _this$props2.additionalPath,
      tabIndex = _this$props2.tabIndex;

    // if (!deviceType) {
    //   console.warn('no device type! TODO: take from url');
    // }

    var providerId = providerData.providerId,
      signedInstance = providerData.signedInstance;
    var urlAdditionalParams = uri(window.location.href).search(true).additionalParams;
    var objUrlAdditionalParams = {};
    if (urlAdditionalParams) {
      objUrlAdditionalParams = uri('/').search(urlAdditionalParams).search(true);
    }
    if (customAdditionalParams) {
      objUrlAdditionalParams = customAdditionalParams;
    }
    var realLocale = locale || this.api.getLocale();
    var realDeviceType = deviceType || this.api.getDeviceType();
    var cachekiller = Date.now();
    var url = this.getProviderBaseUrl();
    var realViewMode = viewMode || this.api.getViewMode();
    var realAdditionalParams = additionalParams || {};
    if (providerId === '147bec5f-d87e-d37b-b5cf-36f47c1815b4' || providerId === '14a0ee97-918b-2f0c-43f1-42e67948716b') {
      // This is specific to the Wix provider.
      realAdditionalParams.biToken = this.api.getBiToken();
    }
    if (this.hasDebug()) {
      realAdditionalParams.debugApp = debugApp;
    }
    var fullUrl = url ? uri(url).segment(additionalPath || '').search(Object.assign({
      pInstance: signedInstance,
      locale: realLocale,
      deviceType: realDeviceType,
      cachekiller: cachekiller,
      anonymousUserId: anonymousUserId,
      viewMode: realViewMode,
      a11y: this.state.isAccessible
    }, realAdditionalParams || {}, objUrlAdditionalParams, {
      token: this.state.token
    })) : '';
    var id = intent + '-frame';
    var iframeIndex = tabIndex;
    var renderComponent = /*#__PURE__*/React.createElement("iframe", {
      tabIndex: iframeIndex,
      src: fullUrl,
      id: id,
      onLoad: function onLoad() {
        setTimeout(function () {
          _this7.props.onIframeLoaded && _this7.props.onIframeLoaded();
        }, 500);
      },
      ref: function ref(r) {
        return _this7.onFrameCreated(r);
      },
      style: {
        height: '100%',
        width: '100%',
        border: 0,
        display: 'block'
      }
    });
    var customIframeStyle = this.props.customIframeStyle || {};
    var providerIntentStyle = _objectSpread(_objectSpread({}, customIframeStyle), {}, {
      height: '100%',
      width: '100%'
    });
    return /*#__PURE__*/React.createElement("div", {
      className: 'provider-intent-wrapper',
      style: providerIntentStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "circle-preloader",
      ref: function ref(_ref) {
        return _this7.loader = _ref;
      }
    }), renderComponent);
  };
  return ProviderIntent;
}(Component);
/* eslint-enable react/prop-types, no-case-declarations, no-mixed-operators */
ProviderIntent.defaultProps = {
  styleParams: {}
};
export default ProviderIntent;